import { HTML_INPUT_TIME_FORMAT, HTML_INPUT_DATE_FORMAT } from '@/mixins/js_config.js'
import MathMixin from './math'
import dateUtil from '@/utils/date_util'

let DateMixin = {
  mixins: [MathMixin],
  methods: {
    isDateTime(value) {
      try {
        if (isNaN(Date.parse(new Date(value.replace(/-/g, '/'))))) {
          return false
        }
      } catch (ex) {
        return false
      }
      return true
    },
    todayTimeRange: function() {
      var beginTime = moment().startOf('day')
      var endTime = moment().endOf('day')
      return [beginTime, endTime]
    },
    yesterdayTimeRange: function() {
      var beginTime = moment()
        .subtract(1, 'days')
        .startOf('day')
      var endTime = moment()
        .subtract(1, 'days')
        .endOf('day')
      return [beginTime, endTime]
    },
    currentWeekTimeRange: function() {
      var beginTime = moment().startOf('week')
      var endTime = moment().endOf('week')
      return [beginTime, endTime]
    },
    prevWeekTimeRange: function() {
      var beginTime = moment()
        .startOf('week')
        .subtract(1, 'week')
      var endTime = moment()
        .endOf('week')
        .subtract(1, 'week')
      return [beginTime, endTime]
    },
    currentMonthTimeRange: function() {
      var beginTime = moment().startOf('month')
      var endTime = moment().endOf('month')
      return [beginTime, endTime]
    },
    prevMonthTimeRange: function() {
      var beginTime = moment()
        .subtract(1, 'months')
        .startOf('month')
      var endTime = moment()
        .subtract(1, 'months')
        .endOf('month')
      return [beginTime, endTime]
    },
    /**
     * 显示时间的距离
     * 兼容 safari
     *
     * @param {string} startTime 开始时间
     * @param {string} endTime 结束时间
     *
     * @returns {string} ''
     */
    displayTimeDuration(startTime, endTime) {
      var duration = ''
      if ($.isEmptyObject(endTime) || $.isEmptyObject(startTime)) {
        if ($.isEmptyObject(endTime) && !$.isEmptyObject(startTime)) {
          duration = (new Date() - new Date(startTime.replace(/-/g, '/'))) / 1000
          return this._formatTime(duration)
        }
        return '-'
      } else {
        duration = (new Date(endTime.replace(/-/g, '/')) - new Date(startTime.replace(/-/g, '/'))) / 1000
        return this._formatTime(duration)
      }
    },
    /**
     * 显示时间的距离
     *
     * @param {string} startTime 开始时间
     * @param {string} endTime 结束时间。如果没有，则获取当前时间
     *
     * @returns {string} 如 1小时2分钟
     */
    displayUtcTimeDuration(startTime, endTime) {
      if (this.isEmptyObject(endTime)) {
        endTime = this.$moment().format(HTML_INPUT_TIME_FORMAT)
      }
      if (this.isEmptyObject(startTime)) {
        return '-'
      }

      if (startTime.indexOf('+0800') === -1) {
        startTime = this.$moment(startTime).format(HTML_INPUT_TIME_FORMAT)
        endTime = this.$moment(endTime).format(HTML_INPUT_TIME_FORMAT)
      }

      if (startTime && endTime) {
        startTime = startTime.replace(/-/g, '/')
        endTime = endTime.replace(/-/g, '/')
        // 计算两个时间相差秒数(时间差单位可以是 years,months,days,minutes,seconds)
        let duration = this.$moment(endTime).diff(this.$moment(startTime), 'seconds')
        let hours = parseInt(duration / 3600)
        let minutes = parseInt((duration % 3600) / 60)
        let seconds = parseInt((duration % 3600) % 60)
        if (hours >= 24) {
          // days
          let days = parseInt(hours / 24)
          let leftHours = hours % 24
          return `${days}天${minutes > 0 ? leftHours + 1 : leftHours}小时` // 忽略多出的秒
        } else if (hours > 0) {
          // hours
          return `${hours}小时${seconds > 0 ? minutes + 1 : minutes}分`
        } else if (minutes > 0) {
          // minutes
          return `${minutes}分${seconds}秒`
        }
        return `${seconds}秒`
      } else {
        return '-'
      }
    },
    /**
     * 格式化显示时间间隙
     *
     * @param {number} seconds 秒
     * @returns {string} 如 1小时2分钟
     */
    formatTimeDuration(seconds) {
      // 如果是空的，则返回 -
      if (this.isEmptyObject(seconds)) return '-'

      return this._formatTime(seconds)
    },
    /**
     * 格式化显示
     *
     * @param {number} duration 相距的秒
     * @returns {string} 格式化
     */
    _formatTime(duration) {
      let hours = parseInt(duration / 3600)
      let minutes = parseInt((duration % 3600) / 60)
      let seconds = parseInt((duration % 3600) % 60)

      if (hours >= 24) {
        // days
        let days = parseInt(hours / 24)
        let leftHours = hours % 24
        return `${days}天${minutes > 0 ? leftHours + 1 : leftHours}小时` // 忽略多出的秒
      } else if (hours > 0) {
        // hours
        return `${hours}小时${seconds > 0 ? minutes + 1 : minutes}分`
      } else if (minutes > 0) {
        // minutes
        return `${minutes}分${seconds}秒`
      }
      return `${seconds}秒`
    },
    /**
     * Timestamp 格式的内容显示
     *
     * @param {string} isotimestamp 标准的完整时间格式
     * @returns {string} 显示的时间
     */
    ts(isotimestamp) {
      if (isotimestamp == null || isotimestamp == '' || isotimestamp === undefined) {
        return '-'
      } else {
        return moment(isotimestamp, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
      }
    },
    /**
     * Timestamp 格式的内容显示
     *
     * @param {string} isotimestamp 标准的完整时间格式
     * @returns {string} 显示的时间
     */
    date(isotimestamp) {
      if (isotimestamp == null || isotimestamp == '' || isotimestamp === undefined) {
        return '-'
      } else {
        return moment(isotimestamp, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD')
      }
    },
    /**
     * Timestamp 格式的内容显示
     *
     * @param {string} isotimestamp 标准的完整时间格式
     * @returns {string} 显示的时间
     */
    time(isotimestamp) {
      if (isotimestamp == null || isotimestamp == '' || isotimestamp === undefined) {
        return '-'
      } else {
        return moment(isotimestamp, 'YYYY-MM-DD HH:mm:ss').format('HH:mm:ss')
      }
    },
    /**
     * 距离现在
     *
     * @param {string} isotimestamp 标准的完整时间格式
     * @returns {string} 显示的时间
     */
    fromNow(isotimestamp) {
      if (isotimestamp == null || isotimestamp == '' || isotimestamp === undefined) {
        return '-'
      }

      return dateUtil.fromNow(moment(isotimestamp, 'YYYY-MM-DD HH:mm:ss'))
    },
    /**
     * 格式化为比较短的信息
     * 主要用于图表
     *
     * @param {string} formatType 格式化类型，支持: day/month/year
     * @param {string} isoTime 时间。2021-10-28T00:00:00Z
     * @param {object} options 选项
     * @param {boolean} options.displayWeekOnDay 如果是天类型，展示week信息
     * @returns {string} 如 1日 / 2月 / 18年
     */
    chartShortDateFromat(formatType, isoTime, options) {
      let time = moment(isoTime)

      if (formatType === 'day') {
        let timestr = ''

        // 格式化为日
        if (time.get('date') == 1) {
          // 每月第一天，需要展示月份，用于区别
          timestr = time.format('M月D日')
        } else {
          timestr = time.format('D日')
        }

        if (options && options.displayWeekOnDay == true && time.weekday() === 0) {
          // 如果需要并且是周一，则展示周几
          return timestr + time.format(' / ddd')
        }

        return timestr
      } else if (formatType === 'month') {
        // 格式化为月
        if (time.get('month') == 0) {
          // 第一个月需要展示年份信息
          return time.format('YY年M月')
        }
        return time.format('M月')
      } else if (formatType === 'year') {
        // 格式化为年
        return time.format('YY年')
      }

      return isoTime
    },
    /**
     * 格式化为长的信息
     * 主要用于图表
     *
     * @param {string} formatType 格式化类型，支持: day/month/year
     * @param {string} isoTime 时间。2021-10-28T00:00:00Z
     * @returns {string} 如 1日 / 2月 / 18年
     */
    chartFullDateFromat(formatType, isoTime) {
      let time = moment(isoTime)

      if (formatType === 'day') {
        return time.format('YYYY年M月D日 dddd')
      } else if (formatType === 'month') {
        return time.format('YYYY年M月')
      } else if (formatType === 'year') {
        // 格式化为年
        return time.format('YYYY年')
      }

      return isoTime
    },
    /**
     * 最近的30天(按参数格式化)
     *
     * @param {number} days 最近的天数
     * @returns {string} 时间范围
     */
    latestDaysParam(days) {
      let currentDay = moment().format(HTML_INPUT_DATE_FORMAT)
      let last30Day = moment()
        .subtract(days, 'days')
        .format(HTML_INPUT_DATE_FORMAT)

      return `${last30Day}~${currentDay}`
    },
    /**
     * 相差的天数
     *
     * @param {string} isoBeginTime 开始时间。如: 2021-11-20 00:00:00
     * @param {string} isoEndTime 结算时间。如: 2021-11-20 23:59:59
     * @returns {number} 天数
     */
    days(isoBeginTime, isoEndTime) {
      let oneSecond = 1000 // 因为结算时间都是标记为23:59:59，实际为 23:59:59.999999，所以需要补 1000
      let milliSeconds = moment(isoEndTime) + oneSecond - moment(isoBeginTime)
      return this.divide(milliSeconds, 60 * 60 * 24 * 1000)
    },
    /**
     * 相差的天数
     *
     * @param {moment} momentBeginTime 开始时间。如: 2021-11-20 00:00:00
     * @param {moment} momentEndTime 结算时间。如: 2021-11-20 23:59:59
     * @returns {number} 天数
     */
    momentDays(momentBeginTime, momentEndTime) {
      let oneSecond = 1000 // 因为结算时间都是标记为23:59:59，实际为 23:59:59.999999，所以需要补 1000
      let milliSeconds = momentEndTime + oneSecond - momentBeginTime
      return this.divide(milliSeconds, 60 * 60 * 24 * 1000)
    },
    /**
     * 星期的展示
     *
     * @param {Array<number>} weeks 星期
     * @returns {string} 格式化后展示 周一、二
     */
    weeksDisplay(weeks) {
      if (weeks) {
        return '周' + weeks.map(week => this.$t(`common.weeks.${week}`)).join(',')
      }
      return '-'
    }
  }
}

export { DateMixin as default }
